module.exports = __webpack_public_path__ + "img/frcground.5920499f.jpg";